module.exports = __webpack_public_path__ + "img/people.4be83dd1.svg";